import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getAuthToken } from '../../../../utils/auth';
import config from '../../../../../config';

const putBulkToggle = async (activeState, publisherId, categoryObj) => {
  const accessToken = getAuthToken();

  const response = await fetch(
    `${config.ApiBaseUrl}/publisher/${publisherId}/articleCategory/${categoryObj.id}/active/${activeState}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const BulkAction = ({ selectedCategory, setArticles }) => {
  const publisherId = useSelector((state) => state.user.publisher?.id);

  const handleToggleArticles = async (activeState) => {
    const success = await putBulkToggle(
      activeState,
      publisherId,
      selectedCategory
    );
    if (success) {
      if (activeState) {
        setArticles((prevState) => {
          const articlesCopy = prevState.map((article) => {
            if (article.category === selectedCategory.name) {
              // eslint-disable-next-line no-param-reassign
              article.isChecked = true;
            }

            return article;
          });
          return articlesCopy;
        });
      } else {
        setArticles((prevState) => {
          const articlesCopy = prevState.map((article) => {
            if (article.category === selectedCategory.name) {
              // eslint-disable-next-line no-param-reassign
              article.isChecked = false;
            }

            return article;
          });
          return articlesCopy;
        });
      }
    }
  };

  return (
    <>
      <button
        type="button"
        className="global__button"
        disabled={selectedCategory.name === 'none'}
        onClick={() => {
          handleToggleArticles(true);
        }}
      >
        <span className="global__button__text">Bulk Activate</span>
      </button>
      <button
        type="button"
        className="global__button"
        disabled={selectedCategory.name === 'none'}
        onClick={() => {
          handleToggleArticles(false);
        }}
      >
        <span className="global__button__text">Bulk De-Activate</span>
      </button>
    </>
  );
};

BulkAction.propTypes = {
  setArticles: PropTypes.node.isRequired,
  selectedCategory: PropTypes.node.isRequired,
};

export default BulkAction;
